module.exports = __webpack_public_path__ + "static/media/Muehle_tn.82f20f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Muehle_tn.jpg
// module id = 764
// module chunks = 0